import angular from 'angular';
import { getNextStatus } from '@/modules/tasks/TaskStatusToggle';

angular.module('cloudX').component('taskStatusToggle', {
  bindings: {
    value: '<',
    onChange: '&',
    showOpenDetail: '<?',
    showSendEmailButton: '<?',
  },
  template: `
  <task-details-modal ng-if="$ctrl.showTaskModal"
                      task="$ctrl.activeTask"
                      show="true"
                      on-close="$ctrl.onTaskModalClosed"
                      on-save="$ctrl.onTaskModalSaved"
                      show-send-email-button="$ctrl.showSendEmailButton">
  </task-details-modal>
    <span class="dropdown" ng-show="$ctrl.value">
      <a ng-if="!$ctrl.saving" ng-click="$ctrl.setNextStatus()">
        <task-status-icon value="$ctrl.value" ng-class="{clickable:$ctrl.hasNextStatus()}"></task-status-icon>
      </a>
      <i class="fa fa-spin fa-spinner" ng-show="$ctrl.saving"></i>
      <a data-toggle="dropdown" aria-haspopup="true"  ng-hide="$ctrl.saving">
        <span class="caret"></span>
      </a>
      <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
        <li class="dropdown-header" ng-if="$ctrl.canUpdate" data-translate="ChangeTaskStatus"></li>
        <li ng-if="$ctrl.canUpdate">
          <a ng-click="$ctrl.setStatus(0)">
            <i class="fa fa-lg fa-circle greyed-out margin5R"></i>
            <span>{{(0 | translateList:'taskstatus':'Todo')}}</span>
          </a>
        </li>
        <li ng-if="$ctrl.canUpdate">
          <a ng-click="$ctrl.setStatus(1)">
            <i class="fa fa-lg fa-circle orange margin5R"></i>
            <span>{{(1 | translateList:'taskstatus':'In progress')}}</span>
          </a>
        </li>
        <li ng-if="$ctrl.canUpdate">
          <a ng-click="$ctrl.setStatus(2)">
            <i class="fa fa-lg fa-circle green margin5R"></i>
            <span>{{(2 | translateList:'taskstatus':'Done')}}</span>
          </a>
        </li>
        <li class="divider" ng-if="$ctrl.canUpdate" ng-show="(!!$ctrl.value.parentId || $ctrl.value.isBlocked) && !$ctrl.value.inapplicable && !$ctrl.value.rejected"></li>
        <li ng-if="$ctrl.canUpdate" ng-show="$ctrl.value.isBlocked">
          <a ng-click="$ctrl.setBlocked(false)">
            <i class="fa fa-lg fa-arrow-circle-up text-primary margin5R"></i>
            <span data-translate="Unblock"></span>
          </a>
        </li>
        <li ng-if="$ctrl.canUpdate" ng-show="!!$ctrl.value.parentId && !$ctrl.value.isBlocked && !$ctrl.value.inapplicable && !$ctrl.value.rejected">
          <a ng-click="$ctrl.setBlocked(true)">
            <i class="fa fa-lg fa-minus-circle text-danger margin5R"></i>
            <span data-translate="Block"></span>
          </a>
        </li>
        <li ng-if="$ctrl.canUpdate" ng-show="!!$ctrl.value.parentId && !$ctrl.value.inapplicable">
          <a ng-click="$ctrl.setInapplicable()">
            <i class="fa fa-lg fa-times-circle margin5R"></i>
            <span data-translate="Inapplicable"></span>
          </a>
        </li>
        <li ng-if="$ctrl.canUpdate" ng-show="!!$ctrl.value.parentId && !$ctrl.value.rejected">
          <a ng-click="$ctrl.setRejected()">
            <i class="fa fa-lg fa-ban margin5R"></i>
            <span data-translate="Rejected"></span>
          </a>
        </li>
        <li class="divider" ng-if="$ctrl.canUpdate" ng-show="$ctrl.showOpenDetail && $ctrl.value.id"></li>
        <li ng-show="$ctrl.showOpenDetail && $ctrl.value.id" ng-if="$ctrl.isTodo" cx-security="'Todo:r'">
         <a ng-click="$ctrl.openTaskDetail($event)">
            <span class="fa fa-fw margin5R"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" class="react-icon" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M464 0H144c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-96 464H48V256h320v208zm96-96h-48V144c0-26.5-21.5-48-48-48H144V48h320v320z"></path></svg></span>
            <span data-translate="OpenTaskDetails"></span>
          </a>
        </li>
        <li ng-show="$ctrl.showOpenDetail && $ctrl.value.id" ng-if="!$ctrl.isTodo" cx-security="'PlannedTask:r'">
          <a ng-click="$ctrl.openTaskDetail($event)">
            <span class="fa fa-fw margin5R"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" class="react-icon" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M464 0H144c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-96 464H48V256h320v208zm96-96h-48V144c0-26.5-21.5-48-48-48H144V48h320v320z"></path></svg></span>
            <span data-translate="OpenTaskDetails"></span>
          </a>
        </li>
      </ul>
    </span>`,

  controller: [
    '$http',
    'appUrls',
    'flySvc',
    'ModalService',
    '$timeout',
    'checkSecurity',
    function($http, appUrls, flySvc, ModalService, $timeout, checkSecurity) {
      const $ctrl = this;
      $ctrl.saving = false;
      $ctrl.$onChanges = function() {
        $ctrl.isTodo = $ctrl.value?.taskLevel === 2;
        $ctrl.canUpdate = $ctrl.isTodo ? checkSecurity('Todo:u') : checkSecurity('PlannedTask:u');
      };

      $ctrl.changeStatus = function(updatedValue) {
        if (!$ctrl.canUpdate) return;
        if (!$ctrl.value || !$ctrl.value.id) return;
        const newValue = angular.extend({}, $ctrl.value, updatedValue);
        if (angular.equals($ctrl.value, newValue)) return;
        $ctrl.saving = true;
        $http.put(`${appUrls.tasks}/api/plannedTasks/UpdateStatus`, newValue).then(
          ({ data }) => {
            $ctrl.onChange({ value: data });
            $ctrl.saving = false;
          },
          error => {
            flySvc.error(error);
            $ctrl.saving = false;
          },
        );
      };
      $ctrl.setStatus = function(status) {
        $ctrl.changeStatus({ status, isBlocked: false, inapplicable: false });
      };
      $ctrl.setBlocked = function(isBlocked) {
        $ctrl.changeStatus({ isBlocked });
      };
      $ctrl.setInapplicable = function() {
        if (!$ctrl.value.parentId) return;
        $ctrl.changeStatus({ inapplicable: true });
      };
      $ctrl.setRejected = function() {
        if (!$ctrl.value.parentId) return;
        $ctrl.changeStatus({ rejected: true });
      };
      $ctrl.setNextStatus = function() {
        if ($ctrl.saving) return;
        if (!$ctrl.canUpdate) return;
        const nextStatus = getNextStatus($ctrl.value);
        if (!nextStatus) return;
        $ctrl.changeStatus(nextStatus);
      };
      $ctrl.hasNextStatus = function() {
        if (!$ctrl.canUpdate) return false;
        if ($ctrl.saving) return false;
        const nextStatus = getNextStatus($ctrl.value);
        return !!nextStatus;
      };

      $ctrl.onTaskModalClosed = task => {
        $timeout(function() {
          $ctrl.showTaskModal = false;
          $ctrl.activeTask = null;
        }, 0);
      };

      $ctrl.onTaskModalSaved = updatedTasks => {
        $timeout(function() {
          $ctrl.showTaskModal = false;
          $ctrl.activeTask = null;

          if (angular.isArray(updatedTasks)) {
            updatedTasks.forEach(todo => {
              if ($ctrl.value.id === todo.id) {
                $ctrl.onChange({ value: todo });
              }
            });
          }
        }, 0);
      };

      $ctrl.openTaskDetail = function($event) {
        if (!$ctrl.value || !$ctrl.value.id) return;

        $event.preventDefault();
        $event.stopPropagation();

        $ctrl.activeTask = $ctrl.value;
        $ctrl.showTaskModal = true;
      };
    },
  ],
});
